.highlightedTitle {
  color: var(--color-secondary);
}
